module.exports = __webpack_public_path__ + "static/media/ltc.c07c2ad9.svg";